module.exports = __webpack_public_path__ + "media/images/icons/reward-ba788ea0210ddbe4f09008ccb63424ed.png";